import angular from 'angular';

import './task.styles.scss';

import MonitoringTaskController from './task.controller';

export default angular.module('autoboard.monitoringTask', [])
  .controller('MonitoringTaskController', MonitoringTaskController)
  .name;
